import React, { Component } from "react";
import { ResetAnalysisReduxStateAction } from "../../../Actions/Analysis";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouterHooks } from "../../../withRouters/withRoutersHook";

class UploadingCSVFile extends Component {
  static propTypes = {
    ResetAnalysisReduxStateAction: PropTypes.func.isRequired,
  };

  handleCancelUpload = () => {
    this.props.ResetAnalysisReduxStateAction();
    window.location.reload();
  };

  render() {
    return (
      <div
        className="flex flex-col w-full items-center justify-center font-inter gap-5 rounded-2xl p-10 border-2 border-dashed border-blue-200 transition-all duration-200"
        style={{ background: "linear-gradient(135deg, #ffffff 0%, #eff6ff 60%, #eef2ff 100%)" }}
      >
        {/* Spinner */}
        <div className="relative flex items-center justify-center w-12 h-12">
          <div className="absolute w-full h-full border-2 border-t-transparent border-primary-blue rounded-full animate-spin"></div>
          <div className="flex items-center justify-center bg-white w-9 h-9 rounded-full z-10 text-xs font-semibold text-primary-blue">
            60%
          </div>
        </div>
        <div className="flex flex-col gap-3 items-center text-center">
          <p className="text-sm font-medium text-gray-700">Uploading File...</p>
          <button
            onClick={this.handleCancelUpload}
            className="flex items-center gap-2 px-4 py-2 rounded-lg bg-gradient-to-r from-gray-50 to-gray-100 border border-gray-200 text-sm font-medium text-gray-600 hover:from-red-50 hover:to-red-100 hover:text-red-500 hover:border-red-200 transition-all duration-150"
          >
            Cancel Upload
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

export default withRouterHooks(
  connect(mapStateToProps, { ResetAnalysisReduxStateAction })(UploadingCSVFile)
);
